import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

export function handleIgnitionLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (command) {
    case 'settings':
      if (access === 'get') {
        return HttpResponse.json(
          { enabled: true, timeout: 60 },
          { status: 200 },
        );
      }
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    case 'status':
      if (access === 'get') {
        // Simulate different responses based on request count
        // In a real implementation, this would track state properly
        const requestCount = Math.random() > 0.5 ? 0 : 1;

        if (requestCount % 2 === 0) {
          // First request - return enabled/timeout
          return HttpResponse.json(
            {
              enabled: true,
              timeout: 60,
            },
            { status: 200 },
          );
        }
        // Second request - return V2Active/timer
        return HttpResponse.json(
          {
            V2Active: true,
            timer: 0,
          },
          { status: 200 },
        );
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for ignition:${command}` },
    { status: 400 },
  );
}
